import { render, staticRenderFns } from "./TheExtraSns.vue?vue&type=template&id=24e0cb29&"
import script from "./TheExtraSns.vue?vue&type=script&lang=js&"
export * from "./TheExtraSns.vue?vue&type=script&lang=js&"
import style0 from "./TheExtraSns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports